<template>
	<div class="page-container">
		<nav-bar title="题库注册" :fixed="true" id="navbar"></nav-bar>
		<!-- 报名表单 -->
		<div class="form-area" v-if="!isSignupSuccess && !isSignupConfirm">
			<van-form @submit="onConfirm" ref="formData" action="">
				<div class="title" v-if="form.agentId > 0">
					<span style="color: #888;">代理编号：{{this.form.agentId}}</span>
				</div>
				<div class="title">
					<span style="color: #409EFF;">请填写以下报名信息</span>
				</div>
				<van-field
					v-model="form.certNum"
					name="certNum"
					label="身份证号"
					placeholder="身份证号码"
					maxlength="18"
					:rules="[{pattern:/^[1-9]\d{5}(18|19|20)\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/,message:'请填写正确的身份证号码'}]"
				/>

				<van-field
					v-model="form.studentName"
					name="studentName"
					label="姓名"
					placeholder="姓名"
					:rules="[{required:true, message:'请填写姓名'}]"
				/>
				<van-field
					v-model="form.mobile"
					name="mobile"
					type="tel"
					label="手机号码"
					placeholder="手机号码"
					maxlength="11"
					:rules="[{pattern:/^1(3[0-9]|5[0-3,5-9]|7[1-3,5-8]|8[0-9])\d{8}$/,message:'请填写正确的手机号码'}]"
				/>
				<div style="margin: 16px">
					<van-button round block type="info" native-type="submit">下一步</van-button>
				</div>
			</van-form>
		</div>

		<div class="confirm-area" v-if="isSignupConfirm">
			<div class="checked-plan">
				<van-cell-group title="请确认您的报名信息" inset>
					<van-cell title="身份证号" :value="form.certNum"/>
					<van-cell title="真实姓名" :value="form.studentName"/>
					<van-cell title="手机号码" :value="form.mobile"/>
					<div style="margin: 16px; text-align: center">
						<van-button round plain type="info" native-type="button" @click="onModify"> 修改</van-button>&nbsp;
						<van-button round type="info" native-type="button" @click="onSubmit"> 确认提交</van-button>
					</div>
				</van-cell-group>
			</div>
		</div>

		<!-- 报名成功 -->
		<div class="checked-area" v-if="isSignupSuccess">
			<van-icon name="checked" color="#67C23A" size="80"/>
			<div><span class="checked-msg">恭喜您，注册成功！</span></div>
			<div class="checked-plan">
				<van-cell-group title="注册信息" inset>
					<van-cell title="身份证号" :value="form.certNum" />
					<van-cell title="姓名" :value="form.studentName" />
					<van-cell title="手机号码" :value="form.mobile" />
					<div style="margin: 16px">
						<van-button
							round
							block
							type="info"
							native-type="button"
							@click="gotoStudy"
						>点击进入在线平台，开始做题吧！
						</van-button>
					</div>
				</van-cell-group>
			</div>
		</div>

		<!-- loading 遮罩层 -->
		<van-overlay :show="showLoading" color="#1989fa">
			<div class="wrapper">
				<div class="block">
					<van-loading size="24px" vertical>
						<span style="color:#4994df">{{ title || '提交中···' }}</span>
					</van-loading>
				</div>
			</div>
		</van-overlay>
	</div>
</template>

<script>
	import {NavBar} from "vant";
	import {generateUser} from "@/api/user";

	export default {
		name: "signup-shuangpu-push",
		components: {NavBar},
		data() {
			return {
				title: '',
				showLoading: false,
				isSignupSuccess: false,
				isSignupConfirm: false,
				searchResult: false,
				showPicker: false,
				showPickerNd: false,
				showPickerDq: false,
				showPickerSy: false,
				showIndexBar: false,
				form: {
					certNum: '',
					mobile: '',
					studentName:'',
					agentId:0
				},
			}
		},
		mounted() {
			const {agent} = this.$route.query;
			if(typeof (agent) !== 'undefined') {
				this.form.agentId = agent;
			}
		},
		methods: {
			onConfirm() {
				console.log("报名信息",this.form)
				this.isSignupConfirm = true;
			},
			onModify() {
				this.isSignupConfirm = false;
			},
			gotoStudy() {
				window.location.href = "/#/viphome?appNo=APP02";
			},
			onSubmit() {
				console.log(this.form)
				this.showLoading = true;
				generateUser({
					certNum: this.form.certNum,
					userName: this.form.studentName,
					mobile: this.form.mobile,
					agentId: this.form.agentId
				})
					.then(() => {
						this.isSignupSuccess = true;
						this.isSignupConfirm = false;
						this.showLoading = false;
					})
					.catch(() => {
						this.showLoading = false;
					});
			},
		}
	}
</script>

<style scoped>
	#navbar {
		background-color: #409eff;
	}

	#navbar /deep/ .van-ellipsis {
		color: #fff !important;
	}

	#navbar /deep/ .van-nav-bar__text {
		color: #fff !important;
	}

	.form-area {
		margin-top: 46px;
	}

	.title {
		margin: 0;
		padding: 16px 16px 16px;
		color: rgba(69, 90, 100, 0.6);
		font-weight: normal;
		font-size: 14px;
		line-height: 16px;
	}

	.checked-area {
		margin-top: 90px;
		text-align: center;
	}

	.confirm-area {
		text-align: center;
	}

	.checked-msg {
		font-size: 14px;
		color: #67c23a;
	}

	.checked-plan {
		text-align: left;
		margin-top: 40px;
	}

	.wrapper {
		display: flex;
		align-items: center;
		justify-content: center;
		height: 100%;
	}

	.block {
		width: 120px;
		height: 120px;
		border-radius: 15px;
		background-color: #fff;
		padding-top: 32px;
	}
</style>
